import _ 					from "lodash";

import Service 				from "./../../Libs/Service";

import { Publisher } 		from "./Publisher";
import { Creative }			from "./Creative";
import { Asset }			from "./Asset";
import { Localization }		from "./Localization";
import { Server }			from "./Server";
import { Version }			from "./Version";
import { ScreenService } 	from "./Screen";
import { Elements } 		from "./Elements";
import { Events } 			from "./Events";
import { Animation } 		from "./Animation";
import { Emitter } 			from "./Emitter";

import SetupSettings		from "../settings/settings";

let Settings = new Service({

	Name: "Settings",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		}

	},

	Actions: {

		// Первоначальная загрузка всех изменённых настроек всех версий одного креатива
		// serverId - нода, с которой пришли данные
		"VersionsSettings": function(creativesVersionSettings, data, size, serverId) {

			let settingsByVersionByCodename = this.getServerMap(this.SettingsByVersionByCodenameByServer, serverId || this.NodeServerId);

			_.each(creativesVersionSettings, (creativePlayableSettings, creativeId) => {

				_.each(creativePlayableSettings, (versionSettings, versionId) => {

					settingsByVersionByCodename[versionId] = {};

					_.each(versionSettings, versionSetting => {

						this.setVersionSetting(versionSetting, serverId);

					});

					Version.markVersionPartAsLoaded(parseInt(versionId), "settings");

				});

				Creative.markCreativePartAsLoaded(parseInt(creativeId), "settings");

			});

		},

		// Первоначальная загрузка всех original настроек (из json файлов игры) всех версий одного креатива
		"VersionsSettingsOriginal": function(creativesVersionSettingsOriginal, data, size, serverId) {

			let settingsOriginalByVersionByCodename = this.getServerMap(this.SettingsOriginalByVersionByCodenameByServer, serverId || this.NodeServerId);

			_.each(creativesVersionSettingsOriginal, (creativeVersionSettingsOriginal, creativeId) => {

				_.each(creativeVersionSettingsOriginal, (versionSettingsOriginal, versionId) => {

					settingsOriginalByVersionByCodename[versionId] = {};

					_.each(versionSettingsOriginal, versionSetting => {

						this.setVersionSettingOriginal(versionSetting, serverId);

					});

					Version.markVersionPartAsLoaded(parseInt(versionId), "settings-original");

				});

				Creative.markCreativePartAsLoaded(parseInt(creativeId), "settings-original");

			});

		},

		// Изменение одной настройки (serverId - нода, с которой пришли данные)
		"VersionSetting": function(data, fullData, size, serverId) {

			let versionId = parseInt(data.versionId);
			let settingCodename = data.settingCodename;
			let versionSetting = data.versionSetting;

			if (versionSetting && versionSetting["version_id"]) { // проверяем через наличие version_id является ли полученная настройка измененной (при сбросе значения сервер возвращает объект настройки из шаблона)

				this.setVersionSetting(versionSetting, serverId);

				if (versionId === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Setting Changed`, [settingCodename, versionSetting.value]);
					Broadcast.call(`Selected Version Setting Changed:${settingCodename}`, [versionSetting.value]);

				}

			} else {

				let settingsByVersionByCodename = this.getServerMap(this.SettingsByVersionByCodenameByServer, serverId || this.NodeServerId);

				if (settingsByVersionByCodename[versionId]) delete settingsByVersionByCodename[versionId][settingCodename];

				if (versionId === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Setting Changed`, [settingCodename, this.getSettingValue(settingCodename)]);
					Broadcast.call(`Selected Version Setting Changed:${settingCodename}`, [this.getSettingValue(settingCodename)]);

				}

			}

			let settingProps = this.getSettingProps(settingCodename);
			if (settingProps?.["options"]?.["refreshOnChange"] && versionId === Version.SelectedVersion?.id) Broadcast.call("Refresh Iframe");

		},

		"AmazonS3UploadProgress": function(data, full_data) {

			Broadcast.call("Amazon S3 upload Progress", [full_data]);

		},

		"MraidioUploadProgress": function(data, full_data) {

			Broadcast.call("Mraidio Upload Progress", [full_data]);

		},

		"SkyKidsUploadProgress": function(data, full_data) {

			Broadcast.call("Sky Kids upload Progress", [full_data]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.SettingsByVersionByCodenameByServer = {};
		this.SettingsOriginalByVersionByCodenameByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

		//Таймауты на сохранение изменившихся настроек
		this.saveSettingValueTimeouts = {};

		// Скрипт подключается первым в превью и пересылает в дашборд ошибки выполнения кода (событие IFrame Data:PreviewFrameError),
		// чтобы ИИ чат мог предложить исправить ошибку в коде плейабла. Отправляется не более 10 ошибок за одну загрузку фрейма.
		// Для Cocos креативов HTML превью создаётся на сервере - там подключается такой же скрипт Creative.PREVIEW_ERROR_CATCHER_SCRIPT (Creative.Versions.mjs)
		this.PREVIEW_ERROR_CATCHER_SCRIPT =
			'<script>(function() {' +
			'	var count = 0;' +
			'	function send(error) { if (count++ >= 10) return; try { parent.postMessage({PreviewFrameError: error}, "*"); } catch (e) {} }' +
			'	window.addEventListener("error", function(e) {' +
			'		var target = e.target;' +
			'		if (target && target !== window && target.tagName) { var src = target.src || target.href || ""; send({message: "Failed to load " + target.tagName.toLowerCase() + (src ? " " + src : ""), source: src}); return; }' +
			'		send({message: e.message || "Unknown error", source: e.filename || "", line: e.lineno || 0, column: e.colno || 0, stack: e.error && e.error.stack ? String(e.error.stack) : ""});' +
			'	}, true);' +
			'	window.addEventListener("unhandledrejection", function(e) {' +
			'		var reason = e.reason;' +
			'		send({message: "Unhandled promise rejection: " + (reason && reason.message ? reason.message : String(reason)), stack: reason && reason.stack ? String(reason.stack) : ""});' +
			'	});' +
			'	var origConsoleError = console.error;' +
			'	console.error = function() {' +
			'		try {' +
			'			var args = Array.prototype.slice.call(arguments);' +
			'			var firstErr = null;' +
			'			for (var i = 0; i < args.length; i++) { if (args[i] instanceof Error) { firstErr = args[i]; break; } }' +
			'			var msg = args.map(function(a) { if (a instanceof Error) return a.message || String(a); if (typeof a === "object") { try { return JSON.stringify(a); } catch(e) { return String(a); } } return String(a); }).join(" ");' +
			'			var stack = (firstErr && firstErr.stack) ? String(firstErr.stack) : "";' +
			'			if (msg) send({message: msg, stack: stack});' +
			'		} catch (e) {}' +
			'		if (origConsoleError) origConsoleError.apply(console, arguments);' +
			'	};' +
			'})();</script>';

		this.PREVIEW_HTML_TEMPLATE =
			'<!DOCTYPE html>' +
			'<html>' +
			'	<body>' +
			this.PREVIEW_ERROR_CATCHER_SCRIPT +
			'		<script>' +
			'			"settings-place"' +
			'		</script>' +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}/DashboardIntegrationScript.min.js"></script>` +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}/MraidSDK.min.js"></script>` +
			'		"scripts-place"' +
			'	</body>' +
			'</html>';

		window.addEventListener("message", e => {

			if (e.data) {

				if (!e.data.log) console.info(`%c<<< SEND FROM IFRAME <<`, 'color: #b400d8', e.data);

				if (e.data["setSettingFromGame"]) {

					// Если запрещено переписывать базовую версию настроек и сейчас выбрана базовая версия
					if (!e.data["setSettingFromGame"]["replaceBase"] && Version.SelectedVersion.Tags.base) return

					this.setSettingValue(e.data["setSettingFromGame"]["settingCodename"], e.data["setSettingFromGame"]["value"]);

				}

				if (e.data.log) console.log(...e.data.log);

				_.each(e.data, (value, key) => {

					Broadcast.call(`IFrame Data:${key}`, [value, e.data]);

				});

			}

		});

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (SettingsByVersionByCodename[versionId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		//Настройки всех версий всех креативов из БД (отличия от значения по умолчанию)
		this.SettingsByVersionByCodename = this.getServerMap(this.SettingsByVersionByCodenameByServer, serverId);
		//Настройки по умолчанию из json файлов
		this.SettingsOriginalByVersionByCodename = this.getServerMap(this.SettingsOriginalByVersionByCodenameByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setVersionSetting(versionSetting, serverId) {

		let settingsByVersionByCodename = this.getServerMap(this.SettingsByVersionByCodenameByServer, serverId || this.NodeServerId);

		if (!settingsByVersionByCodename[versionSetting["version_id"]]) settingsByVersionByCodename[versionSetting["version_id"]] = {};

		settingsByVersionByCodename[versionSetting["version_id"]][versionSetting["codename"]] = versionSetting;

	},

	unsetVersionSetting(versionId, settingCodename) {

		if (this.SettingsByVersionByCodename[versionId]) delete this.SettingsByVersionByCodename[versionId][settingCodename];

	},

	setVersionSettingOriginal(versionSettingOriginal, serverId) {

		let settingsOriginalByVersionByCodename = this.getServerMap(this.SettingsOriginalByVersionByCodenameByServer, serverId || this.NodeServerId);

		if (!settingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]]) settingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]] = {};

		settingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]][versionSettingOriginal["codename"]] = versionSettingOriginal;

	},

	getVersionSettings(version, forThePlayable = false, customOnly = false) {

		if (!version) return Monitoring.clientError(`.getVersionSettings() version not found.`);

		const creative = Creative.getCreative(version['creative_id']);
		if (!creative) return Monitoring.clientError(`.getVersionSettings() creative not found.`);

		let settings = {};

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = version.baseVersionId ||  version.id;

		//Соберём все codename настроек со всех источников
		let settingCodenames = [];

		if (creative.type === 'playable' || creative.type === 'end-card' || creative.type === 'banner' || creative.type === 'storyboard' || creative.type === 'editable-playable') {

			//Настройки по умолчанию записанные в БД в метаданных настроек (metadata_settings таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.CreativePlayableSettingsByCodename));

			//Особые настройки паблишеров записанные в БД в метаданных настроек паблишера (metadata_settings_publisher таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.CreativePlayableSettingsPublisherByCodename[version['publisher_id']]));

			//Кастомные настройки из json файлов настроек креатива (creative_version_settings_original таблица в БД)
			settingCodenames = settingCodenames.concat(_.keys(this.SettingsOriginalByVersionByCodename[baseVersionId]));

		}

		//Берём только уникальные
		settingCodenames = _.uniq(settingCodenames);

		_.each(settingCodenames, settingCodename => {

			let settingProps = this.getSettingProps(settingCodename) || {};

			// Если настройка не предназначена для текущего типа креатива - пропускаем её
			if (!settingProps.creativeType?.[creative.type]) return;

			if (settingProps.type) {

				settings[settingCodename] = settingProps;

				settings[settingCodename]["value"] = this.getSettingValue(settingCodename);
				settings[settingCodename]["version_id"] = version.id;

				if (creative.type === 'playable') settings[settingCodename]["editor"] = {} //2021.11.04 Это нужно чтобы у игр на старой версии шаблона работало автообновление

			} else {

				settings[settingCodename] = this.getSettingValue(settingCodename);

			}

		});

		if (forThePlayable) settings = _.mapValues(settings, setting => {

			let result = setting.type ? _.pick(setting, ['type', 'value', 'control', 'editor', 'version_id']) : setting;

			//2022.01.16 старый creative-template требует values в корне объекта настроек если value настройки = #random
			if (setting.options && setting.options.values) result.values = setting.options.values;

			return result;

		});

		let endCardVersion = Renderer.getEndCardVersion(creative, version);

		if (endCardVersion) {

			let endCardSettings = this.getVersionSettings(endCardVersion, forThePlayable, true);

			_.each(endCardSettings, setting => {

				if (settings[setting.codename]) console.warn(`EndCard Settings conflict! Playable already have setting with codename "${setting.codename}"`);

				settings[setting.codename] = setting;

			});

		}

		return settings;

	},

	isSettingValueChanged(versionId, settingCodename) {

		return !!(this.SettingsByVersionByCodename[versionId] && this.SettingsByVersionByCodename[versionId][settingCodename]);

	},

	revertSettingValue(versionId, settingCodename) {

		Server.sendToSocket({
			RevertCreativeVersionSetting: {
				versionId: versionId,
				settingCodename: settingCodename
			}
		});

	},

	isSettingExist(settingCodename) {

		if (!Publisher.SelectedPublisher || !Creative.SelectedCreative || !Version.SelectedVersion) return false;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = Version.SelectedVersion.baseVersionId || Version.SelectedVersion.id;

		let result = false;

		if (Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_settings таблица в БД)
			if (Metadata.CreativePlayableSettingsByCodename[settingCodename]) result = true;

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_settings_publisher таблица в БД)
			if (Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) result = true;

			//Параметры из json файла настроек креатива (creative_version_settings_original таблица в БД)
			if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) result = true;

		}

		//Параметры записанные в БД у текущей версии креатива (изменённое в дашборде значение, creative_version_settings таблица в БД) не учитываем - там только value находится

		return result;

	},

	getSettingProps(settingCodename, warnings = true) {

		if (!Publisher.SelectedPublisher || !Creative.SelectedCreative || !Version.SelectedVersion) return null;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = Version.SelectedVersion.baseVersionId || Version.SelectedVersion.id;

		let result = null;

		if (Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_settings таблица в БД)
			if (Metadata.CreativePlayableSettingsByCodename[settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.CreativePlayableSettingsByCodename[settingCodename], ["codename", "type", "creativeType", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.CreativePlayableSettingsByCodename[settingCodename].options));

			}

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_settings_publisher таблица в БД)
			if (Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename], ["codename", "type", "creativeType", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename].options));

			}

			//Параметры из json файла настроек креатива (creative_version_settings_original таблица в БД)
			if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

				result = _.extendWith(result || {}, _.pick(this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename], ["codename", "type", "creativeType", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename].options));

			}

		}

		//Параметры записанные в БД у текущей версии креатива (изменённое в дашборде значение, creative_version_settings таблица в БД) не учитываем - там только value находится

		if (!result && warnings) console.log(`Creative version setting props don't found. settingCodename: ${settingCodename}`);

		return result;

	},

	//Значение настройки нужно брать через этот метод, так как она может быть записана в нескольких разных местах
	getSettingValue(settingCodename) {

		//Когда создаётся новый креатив баннера и в нём ещё нет версий тут не будет Version.SelectedVersion
		if (!Version.SelectedVersion) return null;

		return this.getVersionSettingValue(Version.SelectedVersion.id, settingCodename);

	},

	//Здесь возвращаем значение настройки не для текущей версии а для любой
	getVersionSettingValue(versionId, settingCodename) {

		let version = Version.getVersion(versionId);
		if (!version) return null;

		let creative = Creative.getCreative(version['creative_id']);
		if (!creative) return;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = version.baseVersionId || version.id;

		let value = null;

		if (creative.type === 'playable' || creative.type === 'end-card' || creative.type === 'banner' || creative.type === 'storyboard' || creative.type === 'editable-playable') {

			//Значение записанное в БД у текущей версии креатива (изменённое в дашборде значение, creative_version_settings таблица в БД)
			if (this.SettingsByVersionByCodename[version.id] && this.SettingsByVersionByCodename[version.id][settingCodename]) {

				value = this.SettingsByVersionByCodename[version.id][settingCodename]["value"];

				//Значение из json файла настроек креатива (creative_version_settings_original таблица в БД)
			} else if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

				value = this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных настроек паблишера (metadata_settings_publisher таблица в БД)
			} else if (Metadata.CreativePlayableSettingsPublisherByCodename[version['publisher_id']] && Metadata.CreativePlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename] && ('value' in Metadata.CreativePlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename])) {

				value = Metadata.CreativePlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных общих настроек (metadata_settings таблица в БД)
			} else if (Metadata.CreativePlayableSettingsByCodename[settingCodename]) {

				value = Metadata.CreativePlayableSettingsByCodename[settingCodename]["value"];

				//Иначе возвращаем null - значение настройки не найдено
			} else {

				console.warn(`Creative version setting value don't found. selectedCreative: ${creative.codename} selectedVersion: ${version.codename || version.title} settingCodename: ${settingCodename}`);

			}

		}

		//Будем всё время клонировать значение так как контролы для редактирования настроек могут изменить значение настройки-объекта
		//и эти изменения попадут во все креативы если изначальное значение было взято из метаданных
		return _.cloneDeep(value);

	},

	//Такая же функция есть на сервере - если менять здесь, то вероятно нужно менять и там
	getSettingOriginalValue(settingCodename) {

		let baseVersionId = Version.SelectedVersion.baseVersionId ||  Version.SelectedVersion.id;

		//Значение из json файла настроек креатива (creative_version_settings_original таблица в БД)
		if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

			return this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]["value"];

		//Значение по умолчанию записанное в БД в метаданных настроек паблишера (metadata_settings_publisher таблица в БД)
		} else if (Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename] && ('value' in Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename])) {

			return Metadata.CreativePlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]["value"];

		//Значение по умолчанию записанное в БД в метаданны общих настроек (metadata_settings таблица в БД)
		} else if (Metadata.CreativePlayableSettingsByCodename[Publisher.SelectedPublisher.id] && Metadata.CreativePlayableSettingsByCodename[Publisher.SelectedPublisher.id][settingCodename]) {

			return Metadata.CreativePlayableSettingsByCodename[Publisher.SelectedPublisher.id][settingCodename]["value"];

		//Иначе возвращаем null - значение настройки не найдено
		} else {

			console.warn(`Creative version setting original value don't found. settingCodename: ${settingCodename}`);

			return null;

		}

	},

	// Возвращаем объект игровых событий с учетом переименований
	// Переименования действуют только на трекинг
	getTrackingEvents() {

		let events = _.cloneDeep(Settings.getSettingValue('track-events') || []),
			eventsSettings = Settings.getSettingValue('track-events-settings');

		_.each(events, eventProps => {

			if (eventsSettings?.[eventProps.name]?.description) eventProps.description = eventsSettings[eventProps.name].description; // description должно переопределяться первым
			if (eventsSettings?.[eventProps.name]?.name) eventProps.title = eventsSettings[eventProps.name].name;

		});

		return events;

	},

	setSettingValue(settingCodename, value, splitName) {

		console.log("setSettingValue", settingCodename, value + (splitName || ''));

		this.sendDatabaseSetting(settingCodename, value, splitName);

	},

	setSettingValueSafe(settingCodename, value, splitName) {

		console.log("setSettingValueSafe", settingCodename, value);

		let settingProps = this.getSettingProps(settingCodename);

		if (settingProps?.type === 'number') value = parseFloat(value);

		if (typeof value !== 'number' || isNaN(value)) return;

		if (settingProps?.options?.unitsMultiplier) value = value * settingProps.options.unitsMultiplier;

		this.setSettingValue(settingCodename, value, splitName)

	},

	sendDatabaseSetting(settingCodename, value, splitName) {

		let versionId = Version.SelectedVersion.id;

		clearTimeout(this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`]);
		this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`] = setTimeout(() => {

			Server.sendToSocket({
				UpdateCreativeVersionSetting: {
					versionId: Version.SelectedVersion.id,
					settingCodename,
					value,
					splitName
				}
			});

		}, 500);

		let setting = Settings.SettingsByVersionByCodename[Version.SelectedVersion?.id]?.[settingCodename];
		if (!setting) {
			if (!Settings.SettingsByVersionByCodename[Version.SelectedVersion.id]) Settings.SettingsByVersionByCodename[Version.SelectedVersion.id] = {};
			setting = Settings.SettingsByVersionByCodename[Version.SelectedVersion.id][settingCodename] = {};
		}

		if (splitName) {

			if (!setting.value) setting.value = {};
			setting.value[splitName] = value;

		} else {

			setting.value = value;

		}

		//clearTimeout(this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`]);
		//this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`] = setTimeout(() => {

			Broadcast.call("Selected Version Setting Changed", [settingCodename, setting.value]);

		//}, 50);

	},

	setMultiSelectSettingValue(settingCodename, optionName, optionOn) {

		console.log("setMultiSelectSettingValue", optionName, optionOn);

		let settingProps = this.getSettingProps(settingCodename);

		let value = this.getSettingValue(settingCodename);

		if (!_.isArray(value)) throw new Error(`setMultiSelectSettingValue value is not an array! settingCodename: ${settingCodename}, optionName: ${optionName}, optionOn: ${optionOn}`);

		if (optionOn && !value.includes(optionName)) {

			if (value.length < settingProps.options["maximumCheckedCount"]) value.push(optionName);

		} else if (!optionOn && value.includes(optionName)) {

			if (value.length > settingProps.options["minimumCheckedCount"]) value.splice(value.indexOf(optionName), 1);

		}

		this.sendDatabaseSetting(settingCodename, value);

	},

	setCSSSettingValue(settingCodename, propertyName, propertyValue) {

		console.log("setCSSSettingValue", propertyName, propertyValue);

		if (["fontSize", "borderRadius", "height", "width", "left", "right", "top", "bottom"].includes(propertyName)) propertyValue = parseInt(propertyValue);

		let value = this.getSettingValue(settingCodename);

		if (!_.isObject(value)) throw new Error(`setCSSSettingValue value is not an object! settingCodename: ${settingCodename}, propertyName: ${propertyName}, propertyValue: ${propertyValue}`);

		value[propertyName] = propertyValue;

		this.sendDatabaseSetting(settingCodename, value);

	},

	setListSettingValue(settingCodename, propertyValue, listPosition) {

		console.log("setListSettingValue", settingCodename, propertyValue, listPosition);

		let value = this.getSettingValue(settingCodename);

		if (!_.isArray(value)) throw new Error(`setListSettingValue value is not an array! settingCodename: ${settingCodename}, propertyValue: ${propertyValue}, listPosition: ${listPosition}`);

		if (typeof listPosition === "number") {

			if (propertyValue) value[listPosition] = propertyValue;
			else value.splice(listPosition, 1);

		} else {

			if (propertyValue) value.push(propertyValue);

		}

		this.sendDatabaseSetting(settingCodename, value);

	},

	setRangeChancesSettingValue(settingCodename, settingValue, splitName, max) {

		let value = this.getSettingValue(settingCodename);

		if (!_.isObject(value)) throw new Error(`setRangeChancesSettingValue value is not an object! settingCodename: ${settingCodename}, settingValue: ${settingValue}, splitName: ${splitName}`);

		const oldValue = value[splitName];

		value[splitName] = parseInt(settingValue);

		if (value.reduce((a, b) => a + b) > max) value[splitName] = oldValue;

		this.sendDatabaseSetting(settingCodename, value);

	},

	unhideAllVersions() {

		//Отправляем версии рабочей ноды (активные карты - данные выбранного паблишера)
		const versionIds = Object.keys(Version.Versions);

		versionIds.forEach(id => {
			const version = Version.Versions[id];
			if (version.Tags && version.Tags['hidden']) delete version.Tags['hidden'];
		});

		Server.sendToSocket({
			UnhideAllVersions: {
				creativeId: Creative.SelectedCreative.id,
				versionIds: versionIds
			}
		});

		Broadcast.call("Selected Version Switched");

	},

	isHiddenVersions() {

		let res = false;

		const versions = Version.getVersionsByCreative(Creative.SelectedCreative.id);

		_.each(versions, version => {

			if (version.Tags && version.Tags['hidden']) res = true;

		});

		return res;

	},

	uploadToSkyKids(params) {

		Server.sendToSocket({
			SkyKidsUpload: params
		});

	},

	getCurrentVersionAssetsPath() {

		if (!Creative.SelectedCreative || !Version.SelectedVersion) return null;

		return this.getCreativeAssetsPath(Creative.SelectedCreative, Version.SelectedVersion);

	},

	getCreativeAssetsPath(creative, version) {

		let assetsPath = this.getSettingValue("assets-path");
		if (assetsPath) return assetsPath;

		if (creative.options.templatePlayableCodename) return `${location.protocol}//${SetupSettings["domain"]}/playables/${creative.templateProps.options.gitRepositoryName}/${creative.templateProps.options.gitBranchName}/`;
		else if (creative.Tags["external"]) return `${location.protocol}//${SetupSettings["domain"]}/external/${creative.options.projectDirectory}/`;
		else if (creative.type === 'banner') return `${location.protocol}//${SetupSettings["domain"]}/Images/Banners/${version?.templateProps?.codename || 'default'}/`;
		else if (creative.type === 'storyboard') return `${location.protocol}//${SetupSettings["domain"]}/Images/Storyboards/${version?.templateProps?.codename || 'default'}/`;
		else if (creative.type === 'editable-playable') return `${location.protocol}//${SetupSettings["domain"]}/Images/Playables/${version?.templateProps?.codename || 'default'}/`;
		else return `${location.protocol}//${SetupSettings["domain"]}/deploy/${creative.codename}/`

	},

	getFrameSrc(force) {

		if (!Creative.SelectedCreative || !Version.SelectedVersion) return null;

		let creative = Creative.SelectedCreative;

		if (creative.type === 'playable' && creative.Tags.cocos) return this.getFrameSrcForPlayableCocos(force);
		else if (creative.type === 'playable') return this.getFrameSrcForPlayableCreativeTemplate(force);
		else if (creative.type === 'end-card') return this.getFrameSrcForEndCard(force);
		else if (creative.type === 'banner' || creative.type === 'storyboard' || creative.type === 'editable-playable') return this.getFrameSrcForBanner(force);

	},

	getFrameSrcForPlayableCocos(force) {

		return `${location.protocol}//${SetupSettings["domain"]}/version/getCocosTag/${Version.SelectedVersion.id}?v=${Date.now()}`;

	},

	getFrameSrcForPlayableCreativeTemplate(force) {

		let settings = this.getVersionSettings(Version.SelectedVersion, true);

		if (force) settings["version"] = Date.now();

		settings["dashboard-preview-mode"] = true;
		settings["version-name"] = Version.SelectedVersion ? (Version.SelectedVersion["codename"] || Version.SelectedVersion["title"]) : '';

		settings["project-id"] = Creative.SelectedCreative.id || 0;
		settings["project-type"] = 'playable';
		settings["project-title"] = settings["full-title"] = Creative.SelectedCreative.title;
		settings["project-tags"] = Creative.SelectedCreative.Tags;
		settings["version-id"] = Version.SelectedVersion.id || 0;
		settings["mraid-sdk-supported"] = !!Creative.SelectedCreative.options.mraidSDK;

		settings.Assets = Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion));

		// Убираем из ассетов замененные файлы шрифтов
		_.each(settings.Assets, (asset, key) => {

			if (asset.type === 'web-font' && asset.isHidden) delete settings.Assets[key];

		});

		settings.Localization = Localization.cleanVersionLocalization(Localization.getVersionLocalization(Version.SelectedVersion));

		let tag = this.PREVIEW_HTML_TEMPLATE;
		let scripts = '';

		if (!settings["assets-path"]["value"]) settings["assets-path"]["value"] = this.getCurrentVersionAssetsPath();

		let publisher = Publisher.getPublisher(Creative.SelectedCreative["publisher_id"], Publisher.getSelectedServerId());

		if (publisher.options["IncludeScripts"]) {

			_.each(publisher.options["IncludeScripts"], scriptObj => {

				// Если этот скрипт нужно подключать в релиз
				if (scriptObj["dashboard"]) {

					scripts += `\t\t<script src="${location.protocol}//${SetupSettings["domain"]}${scriptObj["path"]}"></script>\n`;

				}

			});

		}

		let endCardVersion = Renderer.getEndCardVersion(Creative.SelectedCreative, Version.SelectedVersion);

		if (endCardVersion) {

			let endCardCreative = Creative.getCreative(endCardVersion['creative_id']);

			if (endCardCreative) {

				scripts += `\t\t<script src="${location.protocol}//${SetupSettings["domain"]}/end-cards/${endCardCreative.templateProps.version}/end-card.pixi.min.js"></script>\n`;

				settings.Screens = ScreenService.getVersionScreens(endCardVersion);
				settings.Elements = Elements.getVersionElements(endCardVersion);
				settings.Events = Events.getVersionEvents(endCardVersion);
				settings.Animations = Animation.getVersionAnimations(endCardVersion);
				settings.AnimationSteps = Animation.getVersionAnimationSteps(endCardVersion);
				settings.Emitters = Emitter.getVersionEmitters(endCardVersion);

				settings.AnimationProperties = Metadata.AnimationProperties;
				settings.EmitterProperties = Metadata.EmitterProperties;
				settings.ElementProperties = Metadata.ElementPropertiesByCodename;
				settings.ElementStyles = Metadata.ElementStylesByCodename;
				//settings.StyleProperties = Metadata.StylesByCodename;

			}

		}

		tag = tag.replace('"settings-place"', 'Settings = ' + this.getFrameSettings(settings) + ';</script>');
		tag = tag.replace('"scripts-place"', scripts);

		let blob = new Blob([tag], {type: "text/html"});

		return URL.createObjectURL(blob);

	},

	getFrameSrcForEndCard(force) {

		let settings = this.getVersionSettings(Version.SelectedVersion, true);

		settings["debug"]["value"] = !!SetupSettings.dev;
		settings["debug-logger"]["value"] = "native";

		settings["project-id"] = Creative.SelectedCreative.id || 0;
		settings["project-type"] = 'end-card';
		settings["project-title"] = Creative.SelectedCreative.title;
		settings["project-tags"] = Creative.SelectedCreative.Tags;

		settings["version-title"] = Version.SelectedVersion ? (Version.SelectedVersion["codename"] || Version.SelectedVersion["title"]) : '';

		settings["dashboard-preview-mode"] = true;
		settings["mraid-sdk-supported"] = true;

		settings.Assets = Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion));
		settings.Localization = Localization.getVersionLocalization(Version.SelectedVersion);
		settings.Screens = ScreenService.getVersionScreens(Version.SelectedVersion);
		settings.Elements = Elements.getVersionElements(Version.SelectedVersion);
		settings.Events = Events.getVersionEvents(Version.SelectedVersion);
		settings.Animations = Animation.getVersionAnimations(Version.SelectedVersion);
		settings.AnimationSteps = Animation.getVersionAnimationSteps(Version.SelectedVersion);
		settings.Emitters = Emitter.getVersionEmitters(Version.SelectedVersion);

		settings.AnimationProperties = Metadata.AnimationProperties;
		settings.EmitterProperties = Metadata.EmitterProperties;
		settings.ElementProperties = Metadata.ElementPropertiesByCodename;
		settings.ElementStyles = Metadata.ElementStylesByCodename;
		//settings.StyleProperties = Metadata.StylesByCodename;

		if (force) settings["version"] = Date.now();

		settings["assets-path"]["value"] = `${location.protocol}//${SetupSettings["domain"]}/Images/EndCards/${Creative.SelectedCreative.templateProps.codename}/`;
		// Код HTMLRenderer уже находится внутри MraidSDK.HTMLRenderer.min.js
		settings["game-code-url"] = false;

		let tag =
			`<!DOCTYPE html>
			<html lang="en">
				<head>
					<base href="${location.protocol}//${SetupSettings["domain"]}/">
					<meta http-equiv="content-type" content="text/html; charset=utf-8">
					<meta charset="UTF-8">
					<style type="text/css">body {background-color: #2f353a}</style>
					${this.PREVIEW_ERROR_CATCHER_SCRIPT}
					<script>
						Settings = ${this.getFrameSettings(settings)};
					</script>
					<script src="${location.protocol}//${SetupSettings["domain"]}/DashboardIntegrationScript.min.js?v=${settings["version"]}"></script>
					<script src="${location.protocol}//${SetupSettings["domain"]}/MraidSDK.HTMLRenderer.min.js?v=${settings["version"]}"></script>
				</head>
				<body></body>
			</html>`;

		let blob = new Blob([tag], {type: "text/html"});

		return URL.createObjectURL(blob);

	},

	getFrameSrcForBanner(force) {

		let settings = this.getVersionSettings(Version.SelectedVersion);

		settings["project-id"] = Creative.SelectedCreative.id || 0;
		settings["project-type"] = Creative.SelectedCreative.type;
		settings["project-title"] = Creative.SelectedCreative.title;
		settings["project-tags"] = Creative.SelectedCreative.Tags;
		settings["banner-sizes"] = Version.SelectedVersion?.options?.sizes;
		settings["banner-size"] = Layout.getPreviewSize();
		settings["banner-size-key"] = Layout.getPreviewSizeKey();

		settings["version-title"] = Version.SelectedVersion ? (Version.SelectedVersion["codename"] || Version.SelectedVersion["title"]) : '';

		settings["dashboard-preview-mode"] = true;
		settings["mraid-sdk-supported"] = true;

		settings.Assets = Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion));
		settings.Localization = Localization.getVersionLocalization(Version.SelectedVersion);
		settings.Screens = ScreenService.getVersionScreens(Version.SelectedVersion);
		settings.Elements = Elements.getVersionElements(Version.SelectedVersion);
		settings.Events = Events.getVersionEvents(Version.SelectedVersion);
		settings.Animations = Animation.getVersionAnimations(Version.SelectedVersion);
		settings.AnimationSteps = Animation.getVersionAnimationSteps(Version.SelectedVersion);
		settings.Emitters = Emitter.getVersionEmitters(Version.SelectedVersion);

		settings.AnimationProperties = Metadata.AnimationProperties;
		settings.EmitterProperties = Metadata.EmitterProperties;
		settings.ElementProperties = Metadata.ElementPropertiesByCodename;
		settings.ElementStyles = Metadata.ElementStylesByCodename;
		//settings.StyleProperties = Metadata.StylesByCodename;

		if (force) settings["version"] = Date.now();

		let defaultAssetsPath = `${location.protocol}//${SetupSettings["domain"]}/Images/${Creative.SelectedCreative?.type === 'storyboard' || Creative.SelectedCreative?.type === 'editable-playable' ? 'Storyboards' : 'Banners'}/${Version.SelectedVersion?.templateProps?.codename || 'default'}/`;

		if (!settings["assets-path"]) {

			settings["assets-path"] = {
				type: "string",
				value: defaultAssetsPath
			};

		} else {

			settings["assets-path"]["value"] = defaultAssetsPath;

		}

		// Код рендерера уже находится внутри MraidSDK.HTMLRenderer.min.js (или MraidSDK.PixiRenderer.min.js у редактируемых плейаблов), а код креатива версии лежит в script.js
		// (MraidSDK сам сообщит "Code Loaded" по onload этого скрипта)
		settings["game-code-url"] = `${location.protocol}//${SetupSettings["domain"]}/project-assets/project-${Version.SelectedVersion["creative_id"]}/version-${Version.SelectedVersion.id}/script.js`;

		// Редактируемые плейаблы рендерятся на PixiJS, остальные креативы этого типа превью - в HTML
		let mraidSDKFileName = Creative.SelectedCreative.type === 'editable-playable' ? 'MraidSDK.PixiRenderer.min.js' : 'MraidSDK.HTMLRenderer.min.js';

		let tag =
			`<!DOCTYPE html>
			<html lang="en">
				<head>
					<base href="${location.protocol}//${SetupSettings["domain"]}/">
					<meta http-equiv="content-type" content="text/html; charset=utf-8">
					<meta charset="UTF-8">
					<style type="text/css">body {background-color: #2f353a}</style>
					${this.PREVIEW_ERROR_CATCHER_SCRIPT}
					<script>
						Settings = ${this.getFrameSettings(settings)};
					</script>
					<script src="${location.protocol}//${SetupSettings["domain"]}/DashboardIntegrationScript.min.js?v=${settings["version"]}"></script>
					<script src="${location.protocol}//${SetupSettings["domain"]}/${mraidSDKFileName}?v=${settings["version"]}"></script>
				</head>
				<body></body>
			</html>`;

		let blob = new Blob([tag], {type: "text/html"});

		return URL.createObjectURL(blob);

	},

	getFrameSettings(settings) {

		return JSON.stringify(settings, null, 4);

	},

	isReleaseAvailable(release, multipleAllowed, scope) {

		if (typeof release === 'string') release = Metadata.ReleasesByCodename?.[release];

		if (!release) return false;

		if (!release['enabled']) return false;

		if (!release.options['scope'].includes(scope)) return false;

		if (multipleAllowed && scope === 'download' && release.codename === 'sky-kids') return false;

		if (release.codename in (Publisher.SelectedPublisher.options['Releases'] || {})) return Publisher.SelectedPublisher.options['Releases'][release.codename];

		return release.options["enabledByDefault"];

	},

	convertHex(value) {

		if (value.length === 4 && value.indexOf('#') === 0) {

			value = value.slice(1);

			value = '#' + value.split('').map(function (hex) {
				return hex + hex;
			}).join('');

		}

		return value;

	}

});

window.Settings = Settings;

export { Settings }

